import { render } from "./BulkEditModal.vue?vue&type=template&id=f917f950&scoped=true"
import script from "./BulkEditModal.vue?vue&type=script&lang=js"
export * from "./BulkEditModal.vue?vue&type=script&lang=js"

import "./BulkEditModal.vue?vue&type=style&index=0&id=f917f950&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f917f950"]])

export default __exports__